export default __webpack_public_path__ + "static/webpush-932558422635817eab7beb138e6e0113.png";